export const environment = {
  production: false,
  authServiceUrl: 'https://rt-test.internal.sparbankensyd.se/service',
  apiUrl: 'https://rt-test.internal.sparbankensyd.se/interests',
  domain: 'rt-test.internal.sparbankensyd.se'
}

